<template>
  <div
    :class="computedClass"
    v-bind="$attrs"
  >
    <div class="jade-page-header__main-navigation">
      <div>
        <jade-icon-button
          v-if="hasOnNavigate && !hideNavigation"
          variant="neutral-ghost"
          :aria-label="navigateType === 'back' ? 'Voltar' : 'Fechar'"
          :icon="navigateType === 'back' ? 'arrow-left' : 'close'"
          @click="$emit('onNavigate')"
        />
      </div>
      <div class="jade-page-header__title">
        <jade-text variant="heading-xsmall">{{ label }}</jade-text>
      </div>
      <div
        v-if="hasTrailingAction || $slots.trailingItem"
        class="jade-page-header__trailing"
      >
        <div
          v-if="hasTrailingAction"
          class="jade-page-header__trailing-action-medium"
        >
          <jade-icon-button
            size="medium"
            variant="neutral-subtle"
            :icon="trailingAction?.icon"
            @click="$emit('trailingActionClick')"
          />
        </div>
        <div
          v-if="hasTrailingAction"
          class="jade-page-header__trailing-action-large"
        >
          <jade-button
            size="medium"
            variant="neutral-subtle"
            :icon="trailingAction?.icon"
            @click="$emit('trailingActionClick')"
          >
            {{ trailingAction.text }}
          </jade-button>
        </div>
        <div>
          <slot name="trailingItem" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import JadeButton from '../JadeButton'
import JadeIconButton from '../JadeIconButton'
import JadeText from '../JadeText'

const NAVIGATE_TAYPE_ENUM = {
  BACK: 'back',
  CLOSE: 'close'
}

export default {
  name: 'JadeNavigationBar',
  components: {
    JadeButton,
    JadeIconButton,
    JadeText
  },

  props: {
    label: {
      type: String,
      required: true
    },
    navigateType: {
      type: String,
      default: NAVIGATE_TAYPE_ENUM.BACK,
      validation: type => Object.values(NAVIGATE_TAYPE_ENUM).includes(type)
    },
    background: {
      type: String,
      default: 'surface',
      validation: background => ['body', 'surface'].includes(background)
    },
    hideNavigation: {
      type: Boolean,
      default: false
    },
    trailingAction: Object,
    tabsNavigation: Object
  },
  computed: {
    computedClass () {
      return {
        'jade-page-header': true,
        [`is-${this.background}`]: this.background,
        'has-tabs':
          this.tabsNavigation && Object.values(this.tabsNavigation)?.length > 0
      }
    },
    hasOnNavigate () {
      return this.$listeners.onNavigate
    },
    hasTrailingAction () {
      return this.trailingAction && Object.keys(this.trailingAction).length > 0
    }
  }
}
</script>
<style scoped>
@import '@stone-payments/jade/css/navigation-bar.css';
</style>
